import { useEffect } from 'react';
import { ServicesMaps } from '../MapReportingProvider';
import { MapStore } from '../store/MapStore';
import { useService } from './useService';

export function useMapStore() {
  const store = useService<MapStore>(ServicesMaps.MapStore);
  useEffect(() => {
    store.fetchDataSources();
  }, []);
  return store;
}